import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Reveal, SectionHeading } from "@/components/Primitives";
import { BLOG_POSTS } from "@/data/site";

export default function Blog() {
  const [featured, ...rest] = BLOG_POSTS;
  return (
    <div>
      <section className="pt-36 pb-16 bg-brand-green">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading light overline="Blog & Resources" title="Pest control tips & insights"
            subtitle="Expert advice to help you protect your home and stay pest-free all year." />
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="grid lg:grid-cols-2 gap-8 items-center bg-white rounded-[2rem] border border-black/5 shadow-sm overflow-hidden">
              <div className="h-72 lg:h-full"><img src={featured.img} alt={featured.title} className="w-full h-full object-cover" /></div>
              <div className="p-8 lg:p-12">
                <Badge className="bg-brand-gold/15 text-brand-green border-0 rounded-full font-semibold">{featured.tag}</Badge>
                <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-brand-green mt-4 leading-tight">{featured.title}</h2>
                <p className="text-brand-muted mt-4 leading-relaxed">{featured.excerpt}</p>
                <div className="flex items-center gap-2 text-brand-muted text-sm mt-6"><Calendar className="h-4 w-4" />{featured.date}</div>
                <Button className="rounded-full bg-brand-green text-white font-semibold mt-6 hover:bg-brand-greenHover">Read Article <ArrowRight className="h-4 w-4 ml-2" /></Button>
              </div>
            </div>
          </Reveal>

          <div className="grid md:grid-cols-2 gap-8 mt-10">
            {rest.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.08}>
                <div className="bg-white rounded-3xl border border-black/5 shadow-sm overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-[transform,box-shadow] duration-300 h-full">
                  <div className="h-56"><img src={p.img} alt={p.title} className="w-full h-full object-cover" /></div>
                  <div className="p-7">
                    <Badge className="bg-brand-gold/15 text-brand-green border-0 rounded-full font-semibold">{p.tag}</Badge>
                    <h3 className="font-heading text-xl font-bold text-brand-green mt-4 leading-snug">{p.title}</h3>
                    <p className="text-brand-muted text-sm mt-3 leading-relaxed">{p.excerpt}</p>
                    <div className="flex items-center justify-between mt-5 pt-5 border-t border-black/5">
                      <span className="flex items-center gap-2 text-brand-muted text-sm"><Calendar className="h-4 w-4" />{p.date}</span>
                      <span className="text-brand-green font-semibold text-sm flex items-center gap-1">Read <ArrowRight className="h-4 w-4" /></span>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-14 text-center bg-brand-green rounded-[2rem] p-10">
            <h3 className="font-heading text-2xl font-extrabold text-white">Ready to protect your property?</h3>
            <Link to="/request-inspection"><Button className="rounded-full bg-brand-gold text-brand-green font-bold h-12 px-8 mt-6 hover:bg-brand-goldHover">Request a Free Inspection <ArrowRight className="h-5 w-5 ml-2" /></Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
